import React, { useState } from 'react';
import './settings.scss';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import { Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import Loader from '../../../components/base/Loader/Loader';
import { getSettingsData } from '../reducer';
import { dateFormatter, RoleFormater } from '../../../utils/formatters';
import { showGlobalConfirm } from '../../System/actions';
import UserForm from './UserForm';
import TextInput from '../../../components/fields/TextInput/TextInput';
import { deleteRole, deleteUser } from '../actions';
import notificationDecorator, {
  errorNotification,
  successNotification,
} from '../../Notifications/notificationDecorator';
import { getResponseError } from '../../../utils/utils';

export default function UserColumn(props) {
  const { loadData = () => {} } = props;
  const [selectedUser, setSelectedUser] = useState(null);
  const [isShowForm, setIsShowForm] = useState(false);
  const [key, setKey] = useState(0);
  const [filter, setFilter] = useState('');
  const dispatch = useDispatch();
  const intl = useIntl();
  const { formatMessage } = intl;
  const {
    userList = [],
    loadingUserList = false,
    loadingCreateUser = false,
    loadingSaveUser = false,
    loadingDeleteUser = false,
  } = useSelector(getSettingsData);

  const cancel = () => {
    setIsShowForm(false);
  };
  const handleCreate = () => {
    setIsShowForm(true);
    setSelectedUser(null);
    setKey(key + 1);
  };
  const handleEdit = item => event => {
    setSelectedUser(item.id);
    setIsShowForm(true);
    event.preventDefault();
    event.stopPropagation();
    setKey(key + 1);
    return false;
  };
  const handleDelete = item => event => {
    dispatch(showGlobalConfirm({
      confirmMessage: formatMessage({ id: 'user.delete' }, { name: item.name }),
      confirmButtonText: formatMessage({ id: 'app.delete' }),
      confirmClassName: 'remove-preset',
    })).then(() => {
      if (selectedUser === item.id) {
        setSelectedUser(null);
        setIsShowForm(false);
      }
      dispatch(deleteUser(item.id)).then(() => {
        loadData();
        successNotification(formatMessage({ id: 'user.delete.title' }), formatMessage({ id: 'user.delete.success' }));
      }).catch(response => {
        errorNotification(formatMessage({ id: 'user.delete.title' }), getResponseError(response));
      });
    }).catch(() => {});

    event.preventDefault();
    event.stopPropagation();
    return false;
  };
  const selectedItem = (userList || []).find(item => item.id === selectedUser);
  const filteredUserList = (userList || []).filter(item => String(item.username).toLowerCase().includes(String(filter).toLowerCase()));
  return (
    <>
      <div className="settings-category frame">
        <Loader loading={loadingUserList || loadingCreateUser || loadingSaveUser || loadingDeleteUser} />
        <div className="settings-header">
          <div className="settings-label">{formatMessage({ id: 'users' })}</div>
          <div className="settings-buttons">
            <Button variant="secondary" onClick={handleCreate}><Icons customIcon icon="plus" /> {formatMessage({ id: 'app.create' })}</Button>
          </div>
        </div>
        <div className="settings-list-find">
          <TextInput
            inputProps={{
              value: filter,
              onChange: e => setFilter(e.target.value),
            }}
            placeholder={formatMessage({ id: 'search' })}
            inputAfter={(
              <div className="search-wrapper">
                <Icons customIcon className="search" width={24} height={24} icon="search" />
              </div>
            )}

          />
        </div>
        <div className="settings-list-wrapper">
          <div className="settings-list custom-scroll-theme with-find">
            {filteredUserList && filteredUserList.map((item, key) => (
              <div
                key={key}
                onClick={() => {
                  setSelectedUser(item.id);
                }}
                className={classNames('settings-menu-item', { selected: selectedUser === item.id })}
              >{item.username}
                <div className="edit-and-delete-buttons">
                  <div className="menu-item-button" onClick={handleEdit(item)}><Icons
                    customIcon
                    icon="pencil"
                    width={16}
                    height={16}
                  />
                  </div>
                  <div className="menu-item-button" onClick={handleDelete(item)}><Icons
                    customIcon
                    icon="trash"
                    width={16}
                    height={16}
                  />
                  </div>
                </div>
              </div>
            ))}
            {!userList || !userList.length ? (
              <div className="empty-list">
                <div className="empty-list-text">{formatMessage({ id: 'users.not.found' })}</div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
      <div className="settings-options frame">
        <div className="settings-header">
          <div className="settings-label">{formatMessage({ id: 'users.general.info' })}</div>
        </div>
        {!selectedItem && !isShowForm ? (
          <div className="settings-form empty-list">
            <div className="empty-list-text">{formatMessage({ id: 'users.need.select' })}</div>
          </div>
        ) : null}

        {isShowForm ? <UserForm key={key} data={selectedItem} cancel={cancel} loadData={loadData} /> : null}
        {selectedItem && !isShowForm
          ? (
            <>
              <div className="settings-form">
                <div className="settings-view-form preset-option">
                  <div className="settings-view-row">
                    <div className="settings-view-label">{formatMessage({ id: 'name' })}:</div>
                    <div className="settings-view-value">{selectedItem.username || ''}</div>
                  </div>
                  <div className="settings-view-row">
                    <div className="settings-view-label">{formatMessage({ id: 'created_at' })}:</div>
                    <div className="settings-view-value">{dateFormatter(selectedItem.created_at)}</div>
                  </div>
                  <div className="settings-view-row">
                    <div className="settings-view-label">{formatMessage({ id: 'role_ids' })}:</div>
                    <div className="settings-view-value"><RoleFormater role={selectedItem.role.id} /></div>
                  </div>
                </div>
              </div>
              <div className="settings-footer">
                <Button className="clear-show" onClick={handleEdit(selectedItem)}>{formatMessage({ id: 'app.edit' })}</Button>
                <Button className="clear-data" variant="secondary" onClick={handleDelete(selectedItem)}>{formatMessage({ id: 'app.delete' })} </Button>
              </div>
            </>
          ) : null}
      </div>
    </>
  );
}
